import moment from 'jalali-moment';

export const IsAdvertisementCloseToExpire = (
  expireDate?: string | null,
): boolean => {
  if (!expireDate) return false;

  const remainingDays = moment(expireDate).diff(moment(), 'days');

  return remainingDays >= 0 && remainingDays <= 7;
};
